import { type NodeProps } from "@xyflow/react";
import { type PlainNode as NodeType } from "features/entities/EntityCreatePage/EntityGraph/nodes/types";

export const PlainNode = ({ data }: NodeProps<NodeType>) => (
  <div
    className="react-flow__node-default"
    style={{
      width: 200,
      height: 100,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    {data.label && <div>{data.label}</div>}
  </div>
);
